<template>
  <div class="page">
    <div class="card pt5">
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="$t('openTools.product')" name="0"></el-tab-pane>
        <el-tab-pane :label="$t('openTools.order')" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <product v-if="activeTab === '0'"></product>
    <order v-if="activeTab === '1'"></order>
  </div>
</template>

<script>
import Product from './Product.vue';
import Order from './Order.vue';

export default {
  name: 'OpenTools',
  components: {
    Product,
    Order,
  },
  data() {
    return {
      activeTab: '0',
    };
  },
};
</script>

<style lang="scss" scoped></style>
